var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup117(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9637 19.1813L16.5087 13.7263L11.0537 19.1813",
    stroke: "#8A8C96",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5085 13.7263V26",
    stroke: "#8A8C96",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9505 22.4406C29.2806 21.7155 30.3314 20.568 30.9369 19.1794C31.5425 17.7907 31.6684 16.24 31.2947 14.7718C30.921 13.3037 30.069 12.0018 28.8733 11.0716C27.6775 10.1415 26.206 9.63599 24.6911 9.63499H22.9728C22.56 8.03836 21.7906 6.55609 20.7225 5.2996C19.6544 4.04312 18.3153 3.04512 16.806 2.38064C15.2967 1.71616 13.6563 1.40249 12.0083 1.46321C10.3603 1.52393 8.74753 1.95746 7.29119 2.7312C5.83485 3.50495 4.57287 4.59878 3.60012 5.93046C2.62737 7.26214 1.96916 8.79701 1.67499 10.4197C1.38081 12.0424 1.45832 13.7106 1.90169 15.299C2.34505 16.8874 3.14274 18.3546 4.23478 19.5904",
    stroke: "#8A8C96",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9637 19.1813L16.5087 13.7263L11.0537 19.1813",
    stroke: "#8A8C96",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup117);
export default __webpack_public_path__ + "static/media/Group117.3bfaefc57d5d7bbd56aa37b28c52543a.svg";
export { ForwardRef as ReactComponent };